$(document).ready(function() {
    $('.profile-images-wrapper').lightGallery({
        selector: '.light-link'
    });
});